// extracted by mini-css-extract-plugin
export default {"link":"NotFound_link__k4nv4","smallArrow":"NotFound_smallArrow__-Rhqy"};